import styled from '@emotion/styled';

export const Title = styled.h1`
  display: block;
  font-size: 2.25rem;
  font-weight: normal;
  margin: 0 0 1.43rem;
  padding-bottom: 1.43rem;
  border-bottom: 1px solid #e5e5e5;
`;
